export interface ItemGroup<T> {
  items: T[];
  itemUUID: string;
}

export const groupByItem = <T>(
  items: T[],
  getItemUUID: (item: T) => string,
): ItemGroup<T>[] => {
  const groups = new Map<string, ItemGroup<T>>();

  for (const item of items) {
    const itemUUID = getItemUUID(item);
    const group = groups.get(itemUUID);
    if (group) {
      group.items.push(item);
    } else {
      groups.set(itemUUID, { items: [item], itemUUID });
    }
  }

  return [...groups.values()];
};
